module.exports = __webpack_public_path__ + "img/navigation_zotl1.299aeb7b.png";